import React from 'react';
import { MdSend } from 'react-icons/md';
import { ForgeButton } from '@tylertech/forge-react';
const FixedChatInput = ({ commonTextareaProps, handleMessageSendClick }) => {
    return (React.createElement("div", { className: "request-sender" },
        React.createElement("div", { className: "chatbot-text-area" },
            React.createElement("textarea", Object.assign({}, commonTextareaProps))),
        React.createElement(ForgeButton, { onClick: handleMessageSendClick },
            React.createElement("button", { className: "send-icon" },
                React.createElement(MdSend, null)))));
};
export default FixedChatInput;
//# sourceMappingURL=FixedChatInput.js.map